import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute, { ProtectedRouteProps } from "./ProtectedRoute";
import Login from "../screens/Login/Login";
import Main from "../screens/Main";
import Dashboard from "../screens/Dashboard/Dashboard";
import { useSelector } from "react-redux";
import { RootState } from "../config/Store";
import { UserState } from "../reducer/AuthReducer";
import Events from "../screens/Events/Events";
import EventBooking from "../screens/Events/EventBookings";
import EventBookingDetail from "../screens/Events/EventBookingDetails";
import Category from "../screens/Category/Category";
import PageBuilder from "../screens/PageBuilder/PageBuilder";
import AddPageBuilder from "../screens/PageBuilder/AddPageBuilder";
import IesaAdvantage from "../screens/IesaAdvantage/IesaAdvantage";
import LeadershipCouncil from "../screens/LeadershipCouncil/LeadershipCouncil";
import OurTeam from "../screens/OurTeam/OurTeam";
import PastPresident from "../screens/PastPresident/PastPresident";
import AboutMain from "../screens/AboutMain/AboutMain";
import Adviser from "../screens/Adviser/Adviser";
import WorkingGroup from "../screens/WorkingGroup/WorkingGroup";
import IndiaBatteryManufacturing from "../screens/IndiaBatteryManufacturing/IndiaBatteryManufacturing";
import StationaryEnergyStorage from "../screens/StationaryEnergyStorage/StationaryEnergyStorage";
import IndiaElectricMobility from "../screens/IndiaElectricMobility/IndiaElectricMobility";
import MediaTags from "../screens/MediaTag/MediaTag";
import MediaList from "../screens/MediaList/MediaList";
import IndiaGreenHydrogen from "../screens/IndiaGreenHydrogen/IndiaGreenHydrogen";
import IndiaRecycling from "../screens/IndiaRecycling/IndiaRecycling";
import MediaKitPresentation from "../screens/MediaKit/MediaKitPresentation";
import UsIndiaEnergyStorage from "../screens/UsIndiaEnergyStorage/UsIndiaEnergyStorage";
import IndustryReport from "../screens/IndustryReport/IndustryReport";
import PurchaseNow from "../screens/IndustryPurchaseNow/PurchaseNow";
import Home from "../screens/ResourceHome/Home";
import Tender from "../screens/Tenders/Tender";
import Presentation from "../screens/Presentations/Presentation";
import KnowledgePaper from "../screens/KnowledgePapers/KnowledgePaper";
import ResourceIndex from "../screens/ResourceIndex/ResourceIndex";
import ResourceWorkingGroup from "../screens/ResourceWorkingGroup/ResourceWorkingGroup";
import Regulation from "../screens/Regulation/Regulation";
import WomenInEnergy from "../screens/WomenInEnergy/WomenInEnergy";
import BessForCI from "../screens/BessForCI/BessForCI";
import IesaIndustryExcellenceAward from "../screens/iesaIndustryExcellenceAward/IesaIndustryExcellenceAward";
import CustomizedApplication from "../screens/CustomizedApplications/CustomizedApplication";
import StartupAndInnovation from "../screens/StartupAndInnovation/StartupAndInnovation";
import UsWebinarSeries from "../screens/UsWebinarSeries/UsWebinarSeries";
import Membership from "../screens/Membership/Membership";
import AcademyPartners from "../screens/AcademyPartners/AcademyPartners";
import ELearningCourses from "../screens/ELearningCourses/ELearningCourses";
import WebinarRecording from "../screens/WebinarRecording/WebinarRecording";
import MileStone from "../screens/MileStone/MileStone";
import Tag from "../screens/Tags/Tag";
import Blog from "../screens/Blogs/Blog";
import Gallery from "../screens/Gallery/Gallery";
import Speaker from "../screens/Speakers/Speaker";
import EventCalendar from "../screens/EventCalelndar/EventCalendar";
import EventDiscount from "../screens/Discount/EventDiscount";
import ConfigureSections from "../screens/ConfigureSections/ConfigureSections";
import ConfigureFeatures from "../screens/ConfigureFeature/ConfigureFeature";
import ConfigurePlan from "../screens/ConfigurePlan/ConfigurePlan";
import MembershipRequests from "../screens/MembershipRequests/MembershipRequestListPage";
import MembershipRequestDetails from "../screens/MembershipRequests/MembershipRequestDetailsPage";
import Subscriptions from "../screens/Subscriptions/Subscriptions";
import AdminUser from "../screens/AdminUser/AdminUser";
import Organization from "../screens/Organization/Organization";
import Customer from "../screens/Customer/Customer";
import ContactUsList from "../screens/ContactUs/ContactUs";
import WebConfigSetting from "../screens/WebConfigSetting/WebConfigSetting";
import Roles from "../screens/Roles/Roles";
import Banners from "../screens/Banner/Banner";
import TestingComment from "../screens/testiMonial/testiMonial";
import EmailSubscribers from "../screens/EmailSubscribers/EmailSubscribers";
import Verticals from "../screens/Verticals/Verticals";
import Academy from "../screens/Academy/Academy";
import Award from "../screens/Award/Award";
import EmailTemplates from "../screens/EmailTemplates/EmailTemplates";
import PrivacyPolicy from "../screens/PrivacyPolicy/index"
import TermCondition from "../screens/TermAndCondition/index";
import Profile from "../screens/Profile/profile";
import ForgotPassword from "../screens/ForgotPassword/ForgotPassword";
import Countries from "../screens/GeoLocations/GeoLocations";
import States from "../screens/States/States";
import Cities from "../screens/Citites/Cities";
import Transaction from "../screens/Transaction/transaction";
const Navigation = () => {
  const login: any = useSelector<RootState, UserState>(
    (state) => state.userLogin
  );

  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    isAuthenticated: localStorage.getItem("token") != null,
    authenticationPath: "/login",
  };

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/login" />} />
      <Route path="/forgot-password" element={<ForgotPassword/>} />
      <Route
        path="/login"
        element={
          defaultProtectedRouteProps.isAuthenticated || login.loginSuccess ? (
            <Navigate replace to="/about" />
          ) : (
            <Login />
          )
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />
        }
      >
          <Route path="/profile" element={<Profile />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event-bookings/:eventId" element={<EventBooking />} />
        <Route
          path="/event-bookings/details/:bookingId"
          element={<EventBookingDetail />}
        />
        <Route path="/transactions" element={<Transaction />} />
        <Route path="/event-calendar" element={<EventCalendar />} />
        <Route path="/category" element={<Category />} />
        <Route path="/page-builder" element={<PageBuilder />} />
        <Route path="/add-page-builder" element={<AddPageBuilder />} />
        <Route path="/iesa-advantage" element={<IesaAdvantage />} />
        <Route path="/leadership-council" element={<LeadershipCouncil />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/past-president" element={<PastPresident />} />
        <Route path="/about" element={<AboutMain />} />
        <Route path="/adviser" element={<Adviser />} />
        <Route path="/working-group" element={<WorkingGroup />} />
        <Route path="/milestone-awards" element={<MileStone />} />
        <Route
          path="/india-battery-manufacturing"
          element={<IndiaBatteryManufacturing />}
        />
        <Route
          path="/stationary-energy-storage"
          element={<StationaryEnergyStorage />}
        />
        <Route
          path="/india-electric-mobility"
          element={<IndiaElectricMobility />}
        />
        <Route path="/media-tags" element={<MediaTags />} />
        <Route path="/tag" element={<Tag />} />
        <Route path="/media-list" element={<MediaList />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/india-green-hydrogen" element={<IndiaGreenHydrogen />} />
        <Route path="/india-recycling" element={<IndiaRecycling />} />
        <Route path="/media-kit" element={<MediaKitPresentation />} />
        <Route
          path="/us-india-energy-storage"
          element={<UsIndiaEnergyStorage />}
        />
        <Route path="/home" element={<Home />} />
        <Route path="/industry-report" element={<IndustryReport />} />
        <Route path="/purchase_now" element={<PurchaseNow />} />
        <Route path="/tender" element={<Tender />} />
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/knowledge-paper" element={<KnowledgePaper />} />
        <Route path="/resource-index" element={<ResourceIndex />} />
        <Route
          path="/resource-working-group"
          element={<ResourceWorkingGroup />}
        />
        <Route path="/representations" element={<Regulation />} />
        <Route path="/regulation" element={<Navigate replace to="/representations" />} />
        <Route path="/women-in-energy" element={<WomenInEnergy />} />
        <Route path="/bess-for-ci" element={<BessForCI />} />
        <Route
          path="/iesa-industry-excellence-award"
          element={<IesaIndustryExcellenceAward />}
        />
        <Route
          path="/customized-applications"
          element={<CustomizedApplication />}
        />
        <Route
          path="/startup-and-innovation"
          element={<StartupAndInnovation />}
        />
        <Route path="/event-discount" element={<EventDiscount />} />
        <Route path="/configure-section" element={<ConfigureSections />} />
        <Route path="/configure-feature" element={<ConfigureFeatures />} />
        <Route path="/subscription" element={<Subscriptions />} />
        <Route path="/configure-plans" element={<ConfigurePlan />} />
        <Route path="/us-webinar-series" element={<UsWebinarSeries />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/membership-requests" element={<MembershipRequests />} />
        <Route
          path="/membership-requests/:id"
          element={<MembershipRequestDetails />}
        />
        <Route path="/academy-partners" element={<AcademyPartners />} />
        <Route path="/e-learning-courses" element={<ELearningCourses />} />
        <Route path="/webinar-recording" element={<WebinarRecording />} />
        <Route path="/speaker" element={<Speaker />} />
        <Route path="/admin-user" element={<AdminUser />} />
        <Route path="/organization" element={<Organization />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/contact-us" element={<ContactUsList />} />
        <Route path="/web-settings" element={<WebConfigSetting />} />
        <Route path="/roles" element={<Roles />} />
        <Route path="/banners" element={<Banners />} />
        <Route path="/testing-comments" element={<TestingComment />} />
        <Route path="/email-subscribers" element={<EmailSubscribers />} />
        <Route path="/verticals" element={<Verticals />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/award" element={<Award />} />
        <Route path="/email-templates" element={<EmailTemplates />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
           <Route path="/term-and-condition" element={<TermCondition />} />
    <Route path="/manage-geolocations" element={<Countries />} />
     <Route path="/states/:id" element={<States />} />
           <Route path="/cities/:id" element={<Cities />} />
      </Route>
      <Route path="*" element={<Navigate replace to="/login" />} />
    </Routes>
  );
};

export default Navigation;
